<template>
  <el-header :height="height" class="header-nav">
    <div :class="{'home' : home}" class="title">
      <router-link to="{ name: 'home' }">
        <span class="mobile"><img src="@/assets/icon-home.svg"></span>
      </router-link>
      <router-link to="{ name: 'home' }">
       <a class="desktop">My Modules</a>
      </router-link>
      <span class="module-name" v-if="!home">
        &nbsp;
        <img src="@/assets/icon-arrow-right.svg">
        &nbsp;
        <p class="name" v-if="name && number">{{label}} - <span v-html="name"></span></p>
      </span>
    </div>
    <el-link type="primary" fontSize="14px" class="caps desktop anchor-button" href="mailto:marketing_121@numberly.com?subject=Marketing One to One - E-learning support">Contact for support</el-link>
    <el-link href="mailto:marketing_121@numberly.com?subject=Marketing One to One - E-learning support" class="mobile"><img src="@/assets/icon-help.svg"></el-link>
  </el-header>
</template>

<script>
import { mapState } from 'vuex' 
export default {
  name: 'Nav',
  props: {
    height: {
      type: String,
      required: true,
    }
  },
  computed: {
  ...mapState({
      name: function(state) { 
        if (state.modules.current) {
          return state.modules.current.title
        } else {
          return null
        }
      },
      number: function(state) { 
        if (state.modules.current) {
          return state.modules.current.id
        } else {
          return null
        }
      },
      label: function(state) { 
        if (state.modules.current) {
          return state.modules.current.label
        } else {
          return null
        }
      }
    }),
    home () { return this.$route.name === 'home'}
  },
  
}
</script>
<style lang="scss" scoped>
  @import '@/styles';

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 2 * 8%;
    color: $primary;
    overflow: hidden;
    a{
      text-decoration: none;
      color: $primary;
    }
    .title {
      line-height: 47px;
      margin: 0;
      border-bottom: 4px solid white;
      transition: all 0.3s ease;
      height: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      &.home {
        border-color: $primary;
      }
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .desktop {
        font-size: 20px;
        white-space: nowrap;
        font-weight: 400;
      }
    }
    .mobile {
      width: 24px;
      height: 24px;
      display: none;
      border: none;
      &:hover, &:focus {
        outline: none;
        background-color: transparent;
      }
    }
    .module-name {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      font-size: 20px;
      font-weight: 400;
      white-space: nowrap;
      .name {
        margin: 0 0 0 4px;
        line-height: 1.25;
        font-size: 18px;
        text-align: left;

        @media (max-width: 900px) {
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100vw - 420px);
        }
        @media (max-width: 700px) {
          overflow: visible;
        }
        @media (max-width: 425px) {
          max-width: calc(100vw - 110px);
          overflow: hidden;
        }
        @media (max-width: 360px) {
          max-width: calc(100vw - 110px);
        }
      }
    }
    button {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 20px;
      margin-left: auto;
    }
    @media (max-width: 900px) {
      padding-left: 25px;
      padding-right: 25px;
    }
    @media (max-width: 700px) {
      padding-left: 10px;
      padding-right: 10px;
      .title {
        line-height: 27px;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
      }
      .mobile {
        display: inline-block;
      }
      .module-name, .desktop {
        font-size: 14px;
        font-weight: 500;
      }

      a {
        margin-right: 0;
        margin-left: auto;
      }
      .desktop {
        display: none;
      }
    }
  }
  .header-nav {
    justify-content: space-between !important;
  }
</style>

<style lang="scss">
.header-nav {
  .module-name {
    .name {
      i {
        color: #4632FF;
      }
    }
  }
}
</style>